<template>
    <div>
        <input id="dropdown-sort" ref="checkbox" type="checkbox" class="dropdownInput" />
        <label for="dropdown-sort" class="btn dropdown-toggle btn-custom-select">
            {{ label }}
        </label>
        <ul class="dropdown-menu dropdown-menu-right">
            <li v-for="option in items" :key="option.id">
                <nuxt-link :to="`${option.url}#product-list`" class="dropdown-item" @click="closeDropdown">
                    {{ option.name }}
                </nuxt-link>
            </li>
        </ul>
    </div>
</template>
<script lang="ts">
export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        items: {
            type: Array as PropType<{ id: number; name: string; url: string }[]>,
            required: true,
        },
    },

    methods: {
        closeDropdown() {
            this.$refs.checkbox.checked = false
        },
    },
}
</script>

<style lang="scss" scoped>
.dropdownInput {
    display: none;
}

.dropdown-toggle {
    background-color: $color-grey;
    border: 0;

    &:hover {
        @media (min-width: 992px) {
            box-shadow: $box-shadow;
        }
    }
}

.dropdownInput:checked {
    box-shadow: $box-shadow;

    & + .dropdown-toggle:after {
        transform: rotate(-45deg);
        margin: 5px 0 0 0;
    }

    ~ .dropdown-menu {
        display: block;
    }
}
</style>
